module.exports = __webpack_public_path__ + "static/media/Apple Watch 42mm Space Gray Aluminum + Black Open.abcb4919.png";